'use client'

import { useEffect } from 'react'
import { ErrorPageShell } from '@/components/ErrorPageShell'

export default function Error({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    // Comprehensive console + server-log so we can debug minified
    // React errors after the fact.
    console.error('[app error boundary]', error)
    console.error('[app error boundary] message:', error?.message)
    console.error('[app error boundary] stack:', error?.stack)
    console.error('[app error boundary] digest:', error?.digest)
    if (error?.message?.includes('#300')) {
      console.error('[app error boundary] React #300: objects rendered as React child. Look for {obj} where {obj.field} was meant.')
    }
    fetch('/api/logs', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({
        level: 'error',
        message: error?.message || 'Unknown error',
        stack: error?.stack,
        digest: error?.digest,
        url: typeof window !== 'undefined' ? window.location.href : undefined,
        userAgent: typeof window !== 'undefined' ? window.navigator.userAgent : undefined,
      }),
    }).then(
      res => { if (!res.ok) console.error('[app error boundary] /api/logs antwortete', res.status) },
      e => console.error('[app error boundary] /api/logs nicht erreichbar', e),
    )
  }, [error])

  return (
    <ErrorPageShell
      eyebrow="Server-Fehler"
      title="Etwas ist schiefgelaufen."
      lead="Beim Laden dieser Seite ist ein Fehler aufgetreten. Bitte erneut versuchen oder zurück zur Übersicht. Der Vorfall wurde automatisch protokolliert."
      primaryAction={{ label: 'Nochmal versuchen', onClick: reset }}
      secondaryAction={{ label: 'Zurück zur Übersicht', href: '/dashboard' }}
      details={{
        summary: 'Fehlerdetails anzeigen',
        body: error?.message || 'Unbekannter Fehler',
        digest: error?.digest,
      }}
    />
  )
}
